import React, {useEffect, useState} from 'react';
import {AvailableAppointment} from '../../models/appointment.model';
import {getDayOfTheWeek, getDateStr} from '../../services/time-helpers.service';
import {STATE} from '../../models/state.model';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSpinner} from '@fortawesome/free-solid-svg-icons/faSpinner';
import {faAngleLeft} from '@fortawesome/free-solid-svg-icons/faAngleLeft';
import {faRotateRight} from '@fortawesome/free-solid-svg-icons/faRotateRight';
import {faAngleRight} from '@fortawesome/free-solid-svg-icons/faAngleRight';

interface DateSelectorProps {
	appointments: AvailableAppointment[];
	selectedDate: string;
	onSelectDate: (date: string) => void;
	loadMoreDates: () => void;
	loadEarlierDates: () => void;
	showLoadMoreDatesBtn: boolean;
	showEarlierDatesBtn: boolean;
	hasLaterDatesLoaded: boolean;
}

const DateSelector = ({appointments, selectedDate, onSelectDate, loadMoreDates, loadEarlierDates, showLoadMoreDatesBtn, showEarlierDatesBtn, hasLaterDatesLoaded}: DateSelectorProps) => {
	const baseButtonClasses = 'flex w-[48px] h-[48px] flex-col justify-center items-center gap-[12px] shrink-0 rounded-full border';
	const [moreDatesButtonState, setMoreDatesButtonState] = useState(STATE.DEFAULT);

	useEffect(() => {
		if (showLoadMoreDatesBtn) {
			setMoreDatesButtonState(STATE.DEFAULT);
		} else {
			setMoreDatesButtonState(STATE.COMPLETED);
		}
	}, [showLoadMoreDatesBtn, appointments]);

	const handleLoadMoreDates = () => {
		setMoreDatesButtonState(STATE.PROCESSING);
		loadMoreDates();
	};

	const handleShowEarlierDates = () => {
		loadEarlierDates();
	};

	const earlierDatesButton = () => {
		if (showEarlierDatesBtn) {
			return (
				<FontAwesomeIcon icon={faAngleLeft} className="flex text-gray-500 cursor-pointer mt-2 w-4 p-2" onClick={handleShowEarlierDates}/>
			);
		}
	};

	const moreDatesButton = () => {
		if (hasLaterDatesLoaded) {
			return (
				<FontAwesomeIcon icon={faAngleRight} className="flex text-gray-500 cursor-pointer mt-2 w-4 p-2" onClick={handleLoadMoreDates}/>
			);
		}
		switch (moreDatesButtonState) {
			case STATE.PROCESSING:
				return (
					<FontAwesomeIcon icon={faSpinner} className="fa-spin mt-4 text-primary w-8"/>
				);
			case STATE.COMPLETED:
				return (
					<button disabled={true} className={baseButtonClasses}>
						<span className="text-[10px] leading-tight">No More Dates</span>
					</button>
				);
			default:
				return (
					<div onClick={handleLoadMoreDates} className="flex-col cursor-pointer flex mt-4 text-primary w-8">
						<FontAwesomeIcon icon={faRotateRight}/>
						<span className="text-[11px] leading-normal">More</span>
					</div>
				);

		}
	};

	return (
		<div className="flex overflow-x-auto gap-2 text-center scroll-x-hide">
			{earlierDatesButton()}
			{appointments.map(item => (
				<div key={item.date}>
					<button
						onClick={() => onSelectDate(item.date)}
						className={`${baseButtonClasses} ${selectedDate === item.date ? 'bg-primary text-white' : ''}`}>
						<span className="text-lg font-semibold">{getDateStr(item.date)}</span>
					</button>
					<div className="text-center text-xs font-light mt-2">{getDayOfTheWeek(item.date)}</div>
				</div>
			))}
			{moreDatesButton()}
		</div>
	);
};

export default DateSelector;
